import {
  Landmark,
  Hotel,
  Building,
  ShoppingBag,
  Building2,
  Cpu,
  GraduationCap,
  HeartPulse,
  Trophy,
  Plane,
  Library,
  Factory,
  Map,
} from "lucide-react";

export const INDUSTRIES = [
  { title: "Government Infrastructure", icon: Landmark, image: "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=1600" },
  { title: "Hospitality", icon: Hotel, image: "https://images.unsplash.com/photo-1777245398213-e95bb34c442a?q=85&w=1600" },
  { title: "Hotels & Resorts", icon: Hotel, image: "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=1600" },
  { title: "Retail", icon: ShoppingBag, image: "https://images.pexels.com/photos/18206310/pexels-photo-18206310.jpeg?w=1600" },
  { title: "Commercial Buildings", icon: Building, image: "https://images.unsplash.com/photo-1614521084980-811d04f6c6cb?q=85&w=1600" },
  { title: "Smart Cities", icon: Cpu, image: "https://images.pexels.com/photos/11310491/pexels-photo-11310491.jpeg?w=1600" },
  { title: "Educational Institutions", icon: GraduationCap, image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=85&w=1600" },
  { title: "Healthcare", icon: HeartPulse, image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=85&w=1600" },
  { title: "Sports Infrastructure", icon: Trophy, image: "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=1600" },
  { title: "Tourism", icon: Plane, image: "https://images.unsplash.com/photo-1777245398213-e95bb34c442a?q=85&w=1600" },
  { title: "Museums & Cultural", icon: Library, image: "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=1600" },
  { title: "Industrial Projects", icon: Factory, image: "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=1600" },
  { title: "Urban Development", icon: Map, image: "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=1600" },
  { title: "Mixed-Use Developments", icon: Building2, image: "https://images.pexels.com/photos/18206310/pexels-photo-18206310.jpeg?w=1600" },
];
